"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _NostrSystem_instances, _NostrSystem_log, _NostrSystem_sockets, _NostrSystem_handleAuth, _NostrSystem_relayCache, _NostrSystem_profileCache, _NostrSystem_relayMetricsCache, _NostrSystem_profileLoader, _NostrSystem_relayMetrics, _NostrSystem_cleanup;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NostrSystem = void 0;
const debug_1 = __importDefault(require("debug"));
const shared_1 = require("@snort/shared");
const connection_1 = require("./connection");
const query_1 = require("./query");
const relay_metric_handler_1 = require("./relay-metric-handler");
const _1 = require(".");
/**
 * Manages nostr content retrieval system
 */
class NostrSystem extends shared_1.ExternalStore {
    constructor(props) {
        super();
        _NostrSystem_instances.add(this);
        _NostrSystem_log.set(this, (0, debug_1.default)("System"));
        /**
         * All currently connected websockets
         */
        _NostrSystem_sockets.set(this, new Map());
        /**
         * All active queries
         */
        this.Queries = new Map();
        /**
         * NIP-42 Auth handler
         */
        _NostrSystem_handleAuth.set(this, void 0);
        /**
         * Storage class for user relay lists
         */
        _NostrSystem_relayCache.set(this, void 0);
        /**
         * Storage class for user profiles
         */
        _NostrSystem_profileCache.set(this, void 0);
        /**
         * Storage class for relay metrics (connects/disconnects)
         */
        _NostrSystem_relayMetricsCache.set(this, void 0);
        /**
         * Profile loading service
         */
        _NostrSystem_profileLoader.set(this, void 0);
        /**
         * Relay metrics handler cache
         */
        _NostrSystem_relayMetrics.set(this, void 0);
        __classPrivateFieldSet(this, _NostrSystem_handleAuth, props.authHandler, "f");
        __classPrivateFieldSet(this, _NostrSystem_relayCache, props.relayCache ?? new _1.UserRelaysCache(), "f");
        __classPrivateFieldSet(this, _NostrSystem_profileCache, props.profileCache ?? new _1.UserProfileCache(), "f");
        __classPrivateFieldSet(this, _NostrSystem_relayMetricsCache, props.relayMetrics ?? new _1.RelayMetricCache(), "f");
        __classPrivateFieldSet(this, _NostrSystem_profileLoader, new _1.ProfileLoaderService(this, __classPrivateFieldGet(this, _NostrSystem_profileCache, "f")), "f");
        __classPrivateFieldSet(this, _NostrSystem_relayMetrics, new relay_metric_handler_1.RelayMetricHandler(__classPrivateFieldGet(this, _NostrSystem_relayMetricsCache, "f")), "f");
        __classPrivateFieldGet(this, _NostrSystem_instances, "m", _NostrSystem_cleanup).call(this);
    }
    /**
     * Profile loader service allows you to request profiles
     */
    get ProfileLoader() {
        return __classPrivateFieldGet(this, _NostrSystem_profileLoader, "f");
    }
    get Sockets() {
        return [...__classPrivateFieldGet(this, _NostrSystem_sockets, "f").values()].map(a => a.snapshot());
    }
    /**
     * Setup caches
     */
    async Init() {
        _1.db.ready = await _1.db.isAvailable();
        const t = [__classPrivateFieldGet(this, _NostrSystem_relayCache, "f").preload(), __classPrivateFieldGet(this, _NostrSystem_profileCache, "f").preload(), __classPrivateFieldGet(this, _NostrSystem_relayMetricsCache, "f").preload()];
        await Promise.all(t);
    }
    /**
     * Connect to a NOSTR relay if not already connected
     */
    async ConnectToRelay(address, options) {
        try {
            const addr = (0, shared_1.unwrap)((0, shared_1.sanitizeRelayUrl)(address));
            if (!__classPrivateFieldGet(this, _NostrSystem_sockets, "f").has(addr)) {
                const c = new connection_1.Connection(addr, options, __classPrivateFieldGet(this, _NostrSystem_handleAuth, "f")?.bind(this));
                __classPrivateFieldGet(this, _NostrSystem_sockets, "f").set(addr, c);
                c.OnEvent = (s, e) => this.OnEvent(s, e);
                c.OnEose = s => this.OnEndOfStoredEvents(c, s);
                c.OnDisconnect = code => this.OnRelayDisconnect(c, code);
                c.OnConnected = r => this.OnRelayConnected(c, r);
                await c.Connect();
            }
            else {
                // update settings if already connected
                (0, shared_1.unwrap)(__classPrivateFieldGet(this, _NostrSystem_sockets, "f").get(addr)).Settings = options;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    OnRelayConnected(c, wasReconnect) {
        if (wasReconnect) {
            for (const [, q] of this.Queries) {
                q.connectionRestored(c);
            }
        }
    }
    OnRelayDisconnect(c, code) {
        __classPrivateFieldGet(this, _NostrSystem_relayMetrics, "f").onDisconnect(c, code);
        for (const [, q] of this.Queries) {
            q.connectionLost(c.Id);
        }
    }
    OnEndOfStoredEvents(c, sub) {
        for (const [, v] of this.Queries) {
            v.eose(sub, c);
        }
    }
    OnEvent(sub, ev) {
        for (const [, v] of this.Queries) {
            v.onEvent(sub, ev);
        }
    }
    /**
     *
     * @param address Relay address URL
     */
    async ConnectEphemeralRelay(address) {
        try {
            const addr = (0, shared_1.unwrap)((0, shared_1.sanitizeRelayUrl)(address));
            if (!__classPrivateFieldGet(this, _NostrSystem_sockets, "f").has(addr)) {
                const c = new connection_1.Connection(addr, { read: true, write: true }, __classPrivateFieldGet(this, _NostrSystem_handleAuth, "f")?.bind(this), true);
                __classPrivateFieldGet(this, _NostrSystem_sockets, "f").set(addr, c);
                c.OnEvent = (s, e) => this.OnEvent(s, e);
                c.OnEose = s => this.OnEndOfStoredEvents(c, s);
                c.OnDisconnect = code => this.OnRelayDisconnect(c, code);
                c.OnConnected = r => this.OnRelayConnected(c, r);
                await c.Connect();
                return c;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * Disconnect from a relay
     */
    DisconnectRelay(address) {
        const c = __classPrivateFieldGet(this, _NostrSystem_sockets, "f").get(address);
        if (c) {
            __classPrivateFieldGet(this, _NostrSystem_sockets, "f").delete(address);
            c.Close();
        }
    }
    GetQuery(id) {
        return this.Queries.get(id);
    }
    Query(type, req) {
        const existing = this.Queries.get(req.id);
        if (existing) {
            // if same instance, just return query
            if (existing.fromInstance === req.instance) {
                return existing;
            }
            const filters = !req.options?.skipDiff
                ? req.buildDiff(__classPrivateFieldGet(this, _NostrSystem_relayCache, "f"), existing.flatFilters)
                : req.build(__classPrivateFieldGet(this, _NostrSystem_relayCache, "f"));
            if (filters.length === 0 && !!req.options?.skipDiff) {
                return existing;
            }
            else {
                for (const subQ of filters) {
                    this.SendQuery(existing, subQ);
                }
                this.notifyChange();
                return existing;
            }
        }
        else {
            const store = new type();
            const filters = req.build(__classPrivateFieldGet(this, _NostrSystem_relayCache, "f"));
            const q = new query_1.Query(req.id, req.instance, store, req.options?.leaveOpen);
            this.Queries.set(req.id, q);
            for (const subQ of filters) {
                this.SendQuery(q, subQ);
            }
            this.notifyChange();
            return q;
        }
    }
    async SendQuery(q, qSend) {
        if (qSend.relay) {
            __classPrivateFieldGet(this, _NostrSystem_log, "f").call(this, "Sending query to %s %O", qSend.relay, qSend);
            const s = __classPrivateFieldGet(this, _NostrSystem_sockets, "f").get(qSend.relay);
            if (s) {
                const qt = q.sendToRelay(s, qSend);
                if (qt) {
                    return [qt];
                }
            }
            else {
                const nc = await this.ConnectEphemeralRelay(qSend.relay);
                if (nc) {
                    const qt = q.sendToRelay(nc, qSend);
                    if (qt) {
                        return [qt];
                    }
                }
                else {
                    console.warn("Failed to connect to new relay for:", qSend.relay, q);
                }
            }
        }
        else {
            const ret = [];
            for (const [a, s] of __classPrivateFieldGet(this, _NostrSystem_sockets, "f")) {
                if (!s.Ephemeral) {
                    __classPrivateFieldGet(this, _NostrSystem_log, "f").call(this, "Sending query to %s %O", a, qSend);
                    const qt = q.sendToRelay(s, qSend);
                    if (qt) {
                        ret.push(qt);
                    }
                }
            }
            return ret;
        }
        return [];
    }
    /**
     * Send events to writable relays
     */
    BroadcastEvent(ev) {
        for (const [, s] of __classPrivateFieldGet(this, _NostrSystem_sockets, "f")) {
            if (!s.Ephemeral) {
                s.SendEvent(ev);
            }
        }
    }
    /**
     * Write an event to a relay then disconnect
     */
    async WriteOnceToRelay(address, ev) {
        const addrClean = (0, shared_1.sanitizeRelayUrl)(address);
        if (!addrClean) {
            throw new Error("Invalid relay address");
        }
        if (__classPrivateFieldGet(this, _NostrSystem_sockets, "f").has(addrClean)) {
            await __classPrivateFieldGet(this, _NostrSystem_sockets, "f").get(addrClean)?.SendAsync(ev);
        }
        else {
            return await new Promise((resolve, reject) => {
                const c = new connection_1.Connection(address, { write: true, read: true }, __classPrivateFieldGet(this, _NostrSystem_handleAuth, "f")?.bind(this), true);
                const t = setTimeout(reject, 5000);
                c.OnConnected = async () => {
                    clearTimeout(t);
                    await c.SendAsync(ev);
                    c.Close();
                    resolve();
                };
                c.Connect();
            });
        }
    }
    takeSnapshot() {
        return {
            queries: [...this.Queries.values()].map(a => {
                return {
                    id: a.id,
                    filters: a.filters,
                    subFilters: [],
                };
            }),
        };
    }
}
exports.NostrSystem = NostrSystem;
_NostrSystem_log = new WeakMap(), _NostrSystem_sockets = new WeakMap(), _NostrSystem_handleAuth = new WeakMap(), _NostrSystem_relayCache = new WeakMap(), _NostrSystem_profileCache = new WeakMap(), _NostrSystem_relayMetricsCache = new WeakMap(), _NostrSystem_profileLoader = new WeakMap(), _NostrSystem_relayMetrics = new WeakMap(), _NostrSystem_instances = new WeakSet(), _NostrSystem_cleanup = function _NostrSystem_cleanup() {
    let changed = false;
    for (const [k, v] of this.Queries) {
        if (v.canRemove()) {
            v.sendClose();
            this.Queries.delete(k);
            __classPrivateFieldGet(this, _NostrSystem_log, "f").call(this, "Deleted query %s", k);
            changed = true;
        }
    }
    if (changed) {
        this.notifyChange();
    }
    setTimeout(() => __classPrivateFieldGet(this, _NostrSystem_instances, "m", _NostrSystem_cleanup).call(this), 1000);
};
//# sourceMappingURL=data:application/json;base64,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